import {
  PaymentMethod,
  BuyOrderType,
  SellOrderType,
} from 'global/Securities/types/transaction';

export function generateOrderLeverageLabel(method: PaymentMethod) {
  let leverageLabel = '';
  switch (method) {
    case PaymentMethod.DayTrade:
      leverageLabel = 'Day Trade';
      break;
    case PaymentMethod.TradingLimit:
      leverageLabel = 'Trading Limit';
      break;
    default:
      leverageLabel = 'Trading Balance';
  }

  return leverageLabel;
}

export function generateOrderTypeLabel(
  orderType: BuyOrderType | SellOrderType,
) {
  let orderTypeLabel = '';
  switch (orderType) {
    case BuyOrderType.AutoBuy:
      orderTypeLabel = 'Auto Buy';
      break;
    case BuyOrderType.LimitOrder:
    default:
      orderTypeLabel = 'Limit Order';
      break;
  }

  return orderTypeLabel;
}

export function generateOrderExpiryLabel(expiry: number) {
  let expiryLabel = '';
  switch (expiry) {
    case 0:
      expiryLabel = 'Good for day';
      break;
    case 1:
      expiryLabel = 'Good till canceled';
      break;
    default:
      expiryLabel = '';
  }

  return expiryLabel;
}
